import { type ResponderItem } from '@atlassian/eoc-responder-names';

export const generateMinuteOptions = () => {
	return Array.from({ length: 20 }, (_, i) => ({
		label: `${i + 1}`,
		value: i + 1,
	}));
};

/**
 * The boolean value that returns true if responder deleted.
 * It should be loaded to get the correct deleted state.
 * @param responder - ResponderItem
 */
export const isResponderDeleted = (responder: ResponderItem) =>
	responder && !responder.isLoading && !responder.isError && responder.deleted;
